import { z } from 'zod';
import { iamCancerValidation } from '../../../IamCancerSchema';
import { CareDocumentDataSchema } from '../CareDocumentDataSchema';
import { CareDocumentColumnSchema } from '../CareDocumentColumnSchema';
import { CareDocumentOvercomeChallengeSchema } from '../CareDocumentOvercomeChallengeSchema';
import { IObject } from '../../../IObject';
import { requiresCaseReferenceNumber } from '../careDocumentChecks';
import {
  dateValidation,
  fullNameValidation,
  requiredString,
  coerceBoolean,
} from '../../../../validation';

export const WorkFocusedPlanDataSchema = CareDocumentDataSchema.extend({
  patient: z.object({
    fullName: fullNameValidation('Patient name is required'),
    dob: dateValidation('Patient date of birth is required'),
    iam: iamCancerValidation("'I am' is a required"),
    work: z
      .object({
        jobTitle: requiredString('Job title is required'),
        dateSignedOff: dateValidation('Date signed off is required'),
        workPattern: requiredString('Work pattern is required'),
        hideHopingToReturnToWorkIn: coerceBoolean(z.boolean()),
        hopingToReturnToWorkIn: z.string().optional(),
      })
      // the answer is only asked for while the question is shown
      .check((ctx) => {
        const { hideHopingToReturnToWorkIn, hopingToReturnToWorkIn } =
          ctx.value;

        if (hideHopingToReturnToWorkIn !== false || hopingToReturnToWorkIn) {
          return;
        }

        ctx.issues.push({
          code: 'custom',
          input: ctx.value,
          path: ['hopingToReturnToWorkIn'],
          message: 'Hoping to return to work is required',
        });
      }),
  }),
  gip: z.object({
    // Optional: L&G's GIP code. Aviva has none and uses policyNumber instead.
    code: z.string().optional(),
  }),
  policyNumber: z.string().optional(),
  workImpact: z.array(CareDocumentColumnSchema),
  planToOvercomeChallenges: z.array(CareDocumentOvercomeChallengeSchema),
  expertFullName: z.string().optional(),
  dateOfConsultation: dateValidation('Date of consultation is required'),
}).check(requiresCaseReferenceNumber);

export type WorkFocusedPlanData = z.infer<typeof WorkFocusedPlanDataSchema>;
export type WorkFocusedPlan = IObject.HasIdTimestamped<WorkFocusedPlanData>;
